import React, { useState } from 'react';
import TeseImg from '../tese';
import Nav from './Nav';
import {Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';


class Tese extends React.Component {
 




  render(){ 
    
     
          return (
                <React.Fragment>
{console.log(TeseImg[0])}

<Nav/>

<div className="mainWrapper wrapper-tese">
                        {Object.keys(TeseImg[0].imgs).map((key, e) => 
                            <div>
                            {TeseImg[0].imgs[e].split('.')[1] === "jpg" || TeseImg[0].imgs[e].split('.')[1] === "png" ?  <div className="fifty"> <img  src={TeseImg[0].imgs[e]} alt=""/> <p> {TeseImg[0].descs[e]}</p> </div>: <div className="fifty"> <video className="teseVideos" height="80vh" width="auto" autoplay="true" controls muted> <source src={TeseImg[0].imgs[e]} type={"video/mp4"}></source> </video>  <p> {TeseImg[0].descs[e]}</p> </div>}
                            </div>
                        )}

                        </div>
                        
                     

                </React.Fragment>
            )
    } }

export default Tese;